import styles from "./Curriculam.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";

import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import { FaInstagram } from "react-icons/fa";
import IconAndName from "../../components/IconAndName/IconAndName";
import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";
import { IoAddCircleOutline } from "react-icons/io5";

const data = [
  {
    _id: "1",
    title: "Accounts",
    uploadedBy: "Staff 1",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "2",
    title: "Accounts",
    uploadedBy: "Staff 1",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "3",
    title: "Accounts",
    uploadedBy: "Staff 1",
    actions: ["Edit", "Delete"],
  },
  {
    _id: "4",
    title: "Accounts",
    uploadedBy: "Staff 1",
    actions: ["Edit", "Delete"],
  },
];


function Curriculam() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handlecreateform = () => {
    dispatch(openModal("uploadDocument"));};

    const  handlecreateaddfolder = () => {
      dispatch(openModal("selectStudents"));

   
  };
  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        document: (
          <div className={styles.documentCell}>
            <input
              type="checkbox"
              style={{ width: "14px", height: "14px" }}
              checked={isChecked}
              onChange={(e) => {
                const checked = e.target.checked;
                setSelectedIds((prev) =>
                  checked
                    ? [...prev, item._id]
                    : prev.filter((id) => id !== item._id)
                );
              }}
            />
            <div className={styles.iconWrapper}>
              <RiFileTextLine className={styles.fileIcon} />
            </div>
            <span className={styles.titleText}>{item.title}</span>
          </div>
        ),
        uploadedBy: item.uploadedBy,
        action: (
          <Action
            options={item.actions}
            onSelect={(opt) => {
              if (opt === "Edit") {
                dispatch(openModal("editDocument"));
              } else if (opt === "Delete") {
                dispatch(openModal("delete"));
              }
            }}
          />
        ),
      };
    });
  };
  
  

  const displayData = getColumnData(data);

  const ActionsData = [
    {
      label: "Send Invite",
      onclick: () => {
        console.log("send invite");
      },
    },
    {
      label: "Update Rooms",
      onclick: () => {
        dispatch(openModal("updateRoom"));
      },
    },
    {
      label: "Update Status",
      onclick: () => {
        dispatch(openModal("statusUpdate"));
      },
    },
    {
      label: "Update Groups",
      onclick: () => {
        dispatch(openModal("updateGroups"));
      },
    },
    {
      label: "Transfer Student",
      onclick: () => {
        dispatch(openModal("TransferStudent"));
      },
    },
    {
      label: "Create Folder",
      onclick: () => {
        dispatch(openModal("createFolder"));
      },
    },
  ];

  const headingsData = [
    {
      title: (
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <input
            type="checkbox"
            style={{ width: "14px", height: "14px" }}
            checked={selectedIds.length === data.length}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds(checked ? data.map((d) => d._id) : []);
            }}
          />
          Document Name
        </div>
      ),
      accessor: "document",
    },
    {
      title: "Uploaded By",
      accessor: "uploadedBy",
    },
    {
      title: "Actions",
      accessor: "action",
    },
  ];
  
  

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        {/* Status boxes */}
        <div className={styles.createForm}>
          <IconAndName
           
            title="Add Folder"
            bgColor="Primary_Color"
            onClick={handlecreateaddfolder}
          />
          <IconAndName
            icon={<IoAddCircleOutline />}
            title="Add Document"
            bgColor="Primary_Color"
            onClick={handlecreateform}
          />
        </div>

        {/* Search and Filters */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar
                placeholder="Search by student name"
                onChange={(e) => console.log(e.target.value)}
              />
            </div>
          </div>

          {/* Student Data Table */}
          <div>
            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default Curriculam;
